import React from 'react'
import Async from 'react-promise'
import PageLoader from 'components/PageLoader'
import { LayoutWithStandardHeader } from 'stylist'
import { postSessionBypass } from 'utils/api'

const Unauthorized = ({ errorMessage = 'Access denied' }) => (
  <LayoutWithStandardHeader>
    <LayoutWithStandardHeader.Main>
      <span>{errorMessage}</span>
    </LayoutWithStandardHeader.Main>
  </LayoutWithStandardHeader>
)

const EnsureSession = ({ errorMessage, children }) => (
  <Async
    promise={postSessionBypass()}
    pending={() => <PageLoader />}
    then={() => children}
    catch={() => <Unauthorized errorMessage={errorMessage} />}
  />
  /* TODO uncomment and remove above Async with this when UL used again
  <Async
    promise={getSessionStatus()}
    pending={() => (<PageLoader />)}
    then={() => children}
    catch={() =>
      window.top.location.replace(
        signInUri(`${
          window.parent.location !== window.location
            ? document.referrer
            : document.location.href
        }`)
      ) || null
    }
  />*/
)

export default EnsureSession



// WEBPACK FOOTER //
// ./src/components/EnsureSession.js